import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NikeConnectOverlayComponent } from './nike-connect-overlay.component';

@NgModule({
	declarations: [NikeConnectOverlayComponent],
	imports: [
		CommonModule
	],
	exports: [
		NikeConnectOverlayComponent
	]
})
export class NikeConnectOverlayModule { }
